import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import NumberInput from '@wandb/weave/common/components/elements/NumberInput';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, Popup} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

type RangeInputProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  log?: boolean;
  logValue?: boolean;
  maxValue?: number;
  minValue?: number;
  onLogChange?: (newVal?: boolean) => void;
  onMaxChange?: (newVal?: number) => void;
  onMinChange?: (newVal?: number) => void;
  stepper?: boolean;
};

const StyledRangeAndOptions = styled.div`
  display: flex;
  justify-content: flex-start;
  
  .number-input__container {
    margin-right: 0px; !important;
  }

  .number-input__input {
    margin-right: 0px !important;
  }

  .ui.button {
    margin-right: 0px;
  }

  > * + * {
    margin-left: 10px !important;
  }
`;

const RangeInput: React.FC<RangeInputProps> = props => {
  return (
    <StyledRangeAndOptions data-test={`range-input-${props.label}`}>
      <NumberInput
        disabled={props.disabled}
        label={`Min ${props.label} value`}
        placeholder="min"
        stepper={false}
        value={props.minValue}
        onChange={newVal => {
          props.onMinChange?.(newVal);
        }}
      />
      <NumberInput
        className="max"
        disabled={props.disabled}
        label={`Max ${props.label} value`}
        placeholder="max"
        stepper={false}
        value={props.maxValue}
        onChange={newVal => {
          props.onMaxChange?.(newVal);
        }}
      />
      {props.log && (
        <Popup
          on="hover"
          position="top center"
          content="Log scale"
          inverted
          size="mini"
          trigger={
            <Button
              disabled={props.disabled}
              toggle
              icon
              active={props.logValue}
              onClick={(e, {value}) => {
                if (props.onLogChange != null) {
                  props.onLogChange(!props.logValue);
                }
              }}>
              <LegacyWBIcon name="log" title="" />
            </Button>
          }
        />
      )}
    </StyledRangeAndOptions>
  );
};

export default RangeInput;
